import { Chip } from '@/global/components/Chip'
import { GridCellParams } from '@/global/components/DataGrid/utils/types'
import { CircleAlertIcon, CircleCheckIcon } from 'lucide-react'

type Status = 'FECHADA' | 'ABERTA'

export function StatusCompetencia({ row }: GridCellParams) {
    const status = row.status as Status

    const renderStatus = () => {
        switch (status) {
            case 'FECHADA':
                return (
                    <Chip
                        label={[
                            <CircleCheckIcon className="mr-2" />,
                            'Fechada',
                        ]}
                        color="success"
                    />
                )
            case 'ABERTA':
                return (
                    <Chip
                        label={[<CircleAlertIcon className="mr-2" />, 'Aberta']}
                        color="info"
                    />
                )
        }
    }

    return renderStatus()
}
